var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ob1-expanding-accordion",
    {
      staticClass: "bg-gray2 px-1",
      attrs: {
        "with-icon": "",
        "icon-name": "icon-rewards",
        "link-title": _vm.advantagesLabel,
        "link-id": "refunds-button",
        "collapsed-block-id": "refunds-detail",
      },
    },
    [
      _c(
        "ul",
        { staticClass: "list-unstyled ms-1 mb-0" },
        [
          _vm.recovery
            ? [
                _c("li", { staticClass: "row mb-1" }, [
                  _c(
                    "span",
                    { staticClass: "col-12 col-md-8 ps-0" },
                    [
                      _c("ob1-liens", {
                        staticClass: "p-0 text-start",
                        attrs: {
                          "is-button": "",
                          "modal-id": _vm.recoveryModalId,
                          "data-bs-toggle": "modal",
                          text: _vm.recovery.label,
                          "data-oevent-label": "vers_popin_reprise",
                          "data-oevent-category":
                            "valeur_reprise_encart_avantages",
                          "data-oevent-action":
                            "en_savoir_plus_sur_la_reprise_avec_ou_sans_bonus",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "col-12 col-md-4 ps-0 fw-bold amount text-end",
                    },
                    [
                      _vm.tunnelMode
                        ? _c("span", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.recovery.details) +
                                "\n                    "
                            ),
                          ])
                        : [
                            _vm.recovery.amountInCents == null
                              ? _c("ob1-liens", {
                                  staticClass: "p-0",
                                  attrs: {
                                    "is-button": "",
                                    "modal-id": _vm.simulatorModalId,
                                    "data-bs-toggle": "modal",
                                    text: _vm.recovery.details,
                                    "data-oevent-label": "vers_simulateur",
                                    "data-oevent-category":
                                      "a_estimer_depuis_la_fiche_produit",
                                    "data-oevent-action":
                                      "j_accede_au_simulateur",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.recovery.amountInCents != null &&
                            _vm.recovery.manualEstimation
                              ? _c("ob1-liens", {
                                  staticClass: "p-0",
                                  attrs: {
                                    "is-button": "",
                                    "modal-id": _vm.simulatorResultModalId,
                                    "data-bs-toggle": "modal",
                                    text: _vm.recovery.details,
                                    "data-oevent-label":
                                      "vers_popin_de_restitution_du_simulateur",
                                    "data-oevent-category":
                                      "estimation_realisee_et_enregistree",
                                    "data-oevent-action":
                                      _vm.toTmsFormat(_vm.recovery.details) +
                                      "_" +
                                      _vm.toTmsFormat(_vm.recovery.deviceModel),
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.recovery.recyclingUrl &&
                            !_vm.recovery.manualEstimation
                              ? _c("ob1-liens", {
                                  staticClass: "p-0",
                                  attrs: {
                                    "is-link": "",
                                    href: _vm.recovery.recyclingUrl,
                                    text: _vm.recovery.details,
                                    "data-oevent-label":
                                      "recycler_votre_ancien_mobile",
                                    "data-oevent-action":
                                      "0€_sur_votre_" +
                                      _vm.recoveryDeviceNameForTms,
                                    "data-oevent-category":
                                      "reprise_mobile_avec_recyclage",
                                    target: "_blank",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.recovery.amountInCents != null &&
                            !_vm.recovery.manualEstimation &&
                            _vm.recovery.recyclingUrl == null
                              ? _c("span", [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.recovery.details) +
                                      "\n                        "
                                  ),
                                ])
                              : _vm._e(),
                          ],
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _vm.recovery.bonus
                  ? _c("li", { staticClass: "row mb-1" }, [
                      _c(
                        "span",
                        { staticClass: "col-12 col-md-8 ps-0" },
                        [
                          _c("ob1-liens", {
                            staticClass: "p-0 text-start",
                            attrs: {
                              "is-button": "",
                              "modal-id": _vm.recoveryModalId,
                              "data-bs-toggle": "modal",
                              text: _vm.refundMessages.bonusTitle,
                              "data-oevent-label": "vers_popin_bonus_reprise",
                              "data-oevent-category":
                                "bonus_reprise_encart_avantages",
                              "data-oevent-action":
                                _vm.recovery.bonus.amountInCents / 100 +
                                "€_sur_votre_nouveau_mobile",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "col-12 col-md-4 ps-0 fw-bold amount text-end",
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.bonusAmountFormat))])]
                      ),
                    ])
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.odrs, function (odr, index) {
            return _c(
              "li",
              { key: index, staticClass: "row mb-1" },
              [
                _c("odr", {
                  staticClass: "ps-0",
                  attrs: {
                    "modal-id": "popin-odr-" + _vm.deviceSeoId + "-" + index,
                    "odr-name": odr.name,
                    "odr-amount-in-cents": odr.amountInCents,
                    "odr-start-date": odr.dates.start,
                    "odr-end-date": odr.dates.end,
                    "odr-link": odr.link,
                    "promo-odr-messages": _vm.refundMessages.odrMessages,
                  },
                }),
              ],
              1
            )
          }),
          _vm._v(" "),
          !_vm.isWithoutAdvantage
            ? _c("li", { staticClass: "row" }, [
                _c("strong", {
                  staticClass: "ps-0",
                  domProps: {
                    innerHTML: _vm._s(_vm.refundMessages.withConditionsLabel),
                  },
                }),
              ])
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }